import token from 'styled-token';
import { addSuffix } from '../util/addSuffix';

/** @mixin lineHeightMixin */
/**
 * Get the line height for the given font type.
 *
 * @example
 * import { lineHeightMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${lineHeightMixin('h1')}
 * `;
 *
 * <Component>h1 line height</Component>
 *
 * @method
 * @param {string} fontType - The `fontType` key for the `lineHeights` object.
 * @param {function} [callback] - An optional callback that will be called with an object with the
 *     line height value and suffix properties. The value returned from the function will be
 *     inserted.
 * @return {Interpolation}
 */
export var lineHeightMixin = function lineHeightMixin(fontType, callback) {
  return token({
    lineHeights: 'lineHeights',
    suffix: 'defaultUnit'
  }, function (_ref) {
    var lineHeights = _ref.lineHeights,
      suffix = _ref.suffix;
    var value = lineHeights && lineHeights[fontType];
    if (typeof callback === 'function') {
      return callback({
        value: value,
        suffix: suffix
      });
    }
    return addSuffix(value, suffix);
  });
};